



























































































































import { defineComponent, reactive, toRefs, PropType, computed, ref, watch, onMounted } from '@vue/composition-api';
import * as Common from "../commons/common"
import DrawArea from "../components/DrawArea.vue";
import { PageItem, DirectionEnum, BaseSheetField, KaitouModeEnum, AnswerText, CurrentModeEnum } from "../modules/student/DigitalReport"
import { SheetField, Sheet } from '../modules/teacher/SaitenList';

export interface Data {
  inputScale: number
  iconSize: number
  isDispIcon: boolean
  baseDistance: number
  baseScale: number
  pinchOffsetX: number
  pinchOffsetY: number
  pinchMarginX: number
  pinchMarginY: number
  touchLength: number
  KaitouModeEnum: Readonly<{None: number; Text: number; FreeLine: number; StraightLine: number; Eraser: number; Delete: number;}>
  KyouzaiModeEnum: Readonly<{Answer: number; SelfScoring: number;}>
  SheetTypeEnum: Readonly<{Report: number; LessonKyouzai: number; LessonTest: number;}>
  CurrentModeEnum: Readonly<{Answer: number; SelfScoring: number; Preview: number;}>
  CorrectStateEnum: Readonly<{Seitou: number; Gotou: number; Tokuten: number}>
  isShowPopovers: boolean[]
  currentDiscription: any
}

export default defineComponent({
  props: {
    pageItems: {
      type: Array as PropType<PageItem[]>,
      required: true
    },
    height: {
      type: Number as PropType<number>,
      required: true
    },
    selectedPageIdx: {
      type: Number as PropType<number>,
      required: true
    },
    selectedFieldIdx: {
      type: Number as PropType<number>,
      required: false,
      default: null
    },
    selectedBaseSheetField: {
      type: BaseSheetField || null as PropType<BaseSheetField | null>,
      required: false,
      default: null
    },
    selectedStamp: {
      required: false,
      default: null,
    },
    drawMode: {
      type: Number as PropType<number>,
      required: true
    },
    direction: {
      type: Number as PropType<number>,
      required: true
    },
    sheet_type: {
      type: Number as PropType<number>,
      required: true
    },
    fontSize: {
      type: Number as PropType<number>,
      required: true
    },
    lineHeight: {
      type: Number as PropType<number>,
      required: true
    },
    keyCode: {
      type: String as PropType<string>,
      required: false,
      default: null
    },
    currentMode: {
      type: Number as PropType<number>,
      required: true,
    },
    fieldMargin: {
      type: Number as PropType<number>,
      required: true
    },
    std_deadline_text: {
      type: String as PropType<string>,
      required: false,
      default: null
    },
    final_deadline_text: {
      type: String as PropType<string>,
      required: false,
      default: null
    },
    drawColor: {
      type: String as PropType<string>,
      required: false,
      default: null
    },
    thickness: {
      type: Number as PropType<number>,
      required: true,
    },
    title: {
      type: String as PropType<string>,
      default: "解答用紙"
    },
    isMarkerModeEnable: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false,
    },
    isEditable: {
      type: Boolean as PropType<boolean>,
      required: true,
    }
  },
  components: {
    "draw-area": DrawArea,
  },
  setup (props, context) {

    const drawAreaRef = ref([]);
    const KyouzaiModeEnum = Object.freeze({Answer: 1, SelfScoring: 2});

    /************************************************************
     * Data
     ************************************************************/

    const state = reactive<Data>({
      inputScale: 70,
      iconSize: 30,
      isDispIcon: true,
      baseDistance: 0,
      baseScale: 0,
      pinchOffsetX: 0,
      pinchOffsetY: 0,
      pinchMarginX: 0,
      pinchMarginY: 0,
      touchLength: 0,
      KaitouModeEnum: KaitouModeEnum,
      KyouzaiModeEnum: KyouzaiModeEnum,
      SheetTypeEnum: Common.SheetTypeEnum,
      CurrentModeEnum: CurrentModeEnum,
      CorrectStateEnum: Common.CorrectStateEnum,
      isShowPopovers: [],
      currentDiscription: null,
    });

    /************************************************************
     * 表示中のpageItem
     ************************************************************/

    const selectedPageItem = computed((): any => {
      return props.pageItems[props.selectedPageIdx];
    });

    /************************************************************
     * 解答方法：画像の設問有無
     ************************************************************/

     const isExistsAnswerTypeImage = computed((): boolean => {
      return props.pageItems.filter(x => x.base_sheet_fields.filter(y => y.answer_type == Common.AnswerTypeEnum.Image).length > 0).length > 0;
    });

    /************************************************************
     * 解答方法：画像の設問がある場合のスライダーによる拡大縮小
     ************************************************************/

     const inputScaleChanged = (event: number) => {
      drawAreaRef.value.forEach((x: InstanceType<typeof DrawArea>) => {
        x.aspectRatio = false;
      });

      state.inputScale = event
    }

    /************************************************************
     * 切り出しコンポーネントkeyの接頭辞
     ************************************************************/

    const cutAreaKeyPrefix = computed((): any => {
      return props.direction == DirectionEnum.Horizon ? "cut-area-h-" : "cut-area-v-";
    });

    /************************************************************
     * 表示領域の高さ
     ************************************************************/

    const areaHeightStyle = computed((): any => {
      const style: any = {};
      const margin = props.direction == DirectionEnum.Horizon ? 56 : 49;
      style["height"] = `${props.height - margin}px`;
      return style;
    });
    
    /************************************************************
     * 画像の親DivのCSSスタイル
     ************************************************************/

    const imageWrapStyle = computed((): any => {
      const style: any = {};
      style["width"] = `${selectedPageItem.value.base_width * scale.value}px`;
      style["height"] = `${selectedPageItem.value.base_height * scale.value}px`;
      return style;
    });

    /************************************************************
     * 設問アイコンクリック
     ************************************************************/

    const changeSelectedBaseSheetField = (idx: number) => {
      if(props.selectedFieldIdx == idx){
        context.emit("change-selected-base-sheet-field", null);
      }else{
        context.emit("change-selected-base-sheet-field", idx);
      }
    }

    /************************************************************
     * 解答・自己採点モード切り替え
     ************************************************************/

    const changeCurrentMode = (currentMode: number) => {
      context.emit("change-current-mode", currentMode);
    }

    /************************************************************
     * スライダーの値を倍率に変換
     ************************************************************/

    const scale = computed((): any => {
      return Number(state.inputScale) / 100;
    });

    /************************************************************
     * 解答済み設問か判定
     ************************************************************/

    const isKaitouCompleted = (sheetField: BaseSheetField) => {
      return sheetField.isKaitouCompleted;
    }

    /************************************************************
     * ページ切り替え
     ************************************************************/

    const pageChanged = (idx: number) => {
      if(idx < 0 || idx + 1 > props.pageItems.length){
        return;
      }
      context.emit("answer-sheet-page-changed", idx);
    }

    /************************************************************
     * is_canvas_drawed設定
     ************************************************************/

    const setIsCanvasDrawed = async (baseSheetField: BaseSheetField, bitCnt: number) => {
      baseSheetField.is_canvas_drawed = bitCnt > 60;
    }

    /************************************************************
     * is_canvas_drawed設定（切出しエリアのmountedで呼ばれる）
     ************************************************************/

    const setIsCanvasDrawedFromChild = async (id: number, bitCnt: number) => {
      let sheetField: BaseSheetField = null;
      for(const pageItem of props.pageItems){
        sheetField = pageItem.base_sheet_fields.find(x => x.id == id);
        if(sheetField){
          break;
        }
      }
      setIsCanvasDrawed(sheetField, bitCnt);
    }

    /************************************************************
     * 切り出しエリアにCanvas描画 親から呼ばれる
     ************************************************************/

    const renderCanvas = () => {
      drawAreaRef.value.forEach((x: InstanceType<typeof DrawArea>) => {
        x.renderCanvas();
      });
    }

    /************************************************************
     * 答案をクリックして設問切替
     ************************************************************/

    const fieldClicked = (e: MouseEvent) => {

      // 倍率を加味したマウス座標を取得
      const x: number = e.offsetX / scale.value;
      const y: number = e.offsetY / scale.value;
      
      // クリックしたマウス座標に位置する設問を取得 無ければnullが返却される
      const baseSheetField = props.pageItems[props.selectedPageIdx].base_sheet_fields
        .filter(baseSheetField => baseSheetField != props.selectedBaseSheetField 
          && x >= baseSheetField.x
          && baseSheetField.x + baseSheetField.width >= x
          && y >= baseSheetField.y
          && baseSheetField.y + baseSheetField.height >= y
        ).sort((a, b) => a.id - b.id)[0] || null;

      // 設問が存在する位置であれば設問切替、設問が存在しない場合は何もしない
      if(baseSheetField){
        const idx = props.pageItems[props.selectedPageIdx].base_sheet_fields.indexOf(baseSheetField)
        changeSelectedBaseSheetField(idx);        
      }
    }

    /************************************************************
     * canvas編集後のbase64文字列保存
     * DrawAreaコンポーネントから呼ばれる
     ************************************************************/

    const updateCanvas = (base64Canvas: string, bitCnt: number) => {
      props.selectedBaseSheetField.base64_canvas = base64Canvas;
      props.selectedBaseSheetField.is_canvas_updated = true;
      setIsCanvasDrawed(props.selectedBaseSheetField, bitCnt);
      context.emit("set-draw-mode-cache", Common.DrawModeEnum.FreeLine);
    }

    /************************************************************
     * 選択中のテキストスタンプ切り替え
     ************************************************************/

    const changeSelectedStamp = (selectedStamp: any) => {
      context.emit("change-selected-stamp", selectedStamp);
    }

    /************************************************************
     * テキストスタンプ追加 切り出しコンポーネントから呼ばれる
     ************************************************************/

    const addTextStamp = (param: any) => {
      // 選択肢の場合はテキスト追加しない
      if(props.selectedBaseSheetField.answer_type == Common.AnswerTypeEnum.Choice){
        return;
      }
      const size = Common.getTextSize({text: "", fontSize: props.fontSize, lineHeight: props.lineHeight, direction: context.root.$store.state.textDirection});
      const answerText = new AnswerText();
      answerText.base_sheet_field_id = props.selectedBaseSheetField.id;
      answerText.idx = props.selectedBaseSheetField.answer_text_idx++;
      answerText.font_size = props.fontSize;
      answerText.line_height = 0;
      answerText.color = "#000000";
      answerText.x = param.point.x;
      answerText.y = param.point.y;
      answerText.width = size.width;
      answerText.height = size.height;
      answerText.direction = context.root.$store.state.textDirection;
      answerText.base64_text = Common.createBase64Text(answerText);
      context.emit("add-text-stamp", answerText);
    }

    /************************************************************
     * テキストスタンプ削除 切り出しコンポーネントから呼ばれる
     ************************************************************/

    const deleteTextStamp = (stamp: any) => {
      context.emit("delete-text-stamp", stamp);
    }

    /************************************************************
     * 画像スタンプ削除 切り出しコンポーネントから呼ばれる
     ************************************************************/

    const deleteImageStamp = (stamp: any) => {
      context.emit("delete-image-stamp", stamp);
    }

    /************************************************************
     * ショートカットキー＋マウスダウンによる解答モード変更
     * 切り出しコンポーネントから呼ばれる
     ************************************************************/

    const changeDrawModeFromChild = (drawMode: number) => {
      context.emit("change-draw-mode-from-child", drawMode);
    }

    /************************************************************
     * 画像上をtouchstart
     ************************************************************/

    const imageAreaTouchstart = (e: TouchEvent) => {
      state.touchLength = e.touches.length;
    }

    /************************************************************
     * ピンチによる拡大縮小
     ************************************************************/

    const imageAreaTouchmove = (e: TouchEvent) => {

      state.touchLength = e.touches.length;

      if(e.touches.length > 1){
        
        e.preventDefault();

        const touches = e.touches;

        const x1 = touches[0].screenX;
        const y1 = touches[0].screenY;

        const x2 = touches[1].screenX;
        const y2 = touches[1].screenY;

        const distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
        
        if(state.baseDistance){
          const addScale = distance - state.baseDistance;
          
          // 値が低いほど早く拡大縮小する
          const pinchSpeed = 3;

          const newScale = state.baseScale + addScale / pinchSpeed;
          
          if(newScale >= 10 && newScale <= 200){
            state.inputScale = newScale;

            const offsetX = state.pinchOffsetX * scale.value;
            const offsetY = state.pinchOffsetY * scale.value;

            const pageRoot = document.getElementById(`answer-page-root-${props.direction}-${props.sheet_type}`);
            pageRoot.scrollLeft = offsetX - state.pinchMarginX;
            pageRoot.scrollTop = offsetY - state.pinchMarginY;
          }
          
        }else{
          state.baseDistance = distance;
          state.baseScale = Number(state.inputScale);
          
          const offsetXs = [];
          const offsetYs = [];

          for(let i = 0; i < 2; i++){
            const touch = e.touches[i];
            const touchElement = touch.target as HTMLElement;
            const bounds = touchElement.getBoundingClientRect();
            
            if(touchElement.id.includes("canvas")){
              // タッチしている要素が切り出しcanvasの場合
              const parentDiv = document.getElementById(touchElement.id.replace("canvas", "parent"));
              offsetXs.push(touch.clientX - window.pageXOffset - bounds.left + parseInt(parentDiv.style.left));
              offsetYs.push(touch.clientY - window.pageYOffset - bounds.top + parseInt(parentDiv.style.top));
            }else if(touchElement.id.includes("pencil")){
              // タッチしている要素が設問ペンシルの場合
              const parentDiv = document.getElementById(touchElement.id.replace("pencil", "pencil-parent"));
              offsetXs.push(touch.clientX - window.pageXOffset - bounds.left + parseInt(parentDiv.style.left));
              offsetYs.push(touch.clientY - window.pageYOffset - bounds.top + parseInt(parentDiv.style.top));
            }else if(touchElement.localName == "path"){
              // タッチしている要素が設問ペンシルSVGのpath要素の場合
              const pencilId = touchElement.parentElement.id;
              const parentDiv = document.getElementById(pencilId.replace("pencil", "pencil-parent"));
              offsetXs.push(touch.clientX - window.pageXOffset - bounds.left + parseInt(parentDiv.style.left));
              offsetYs.push(touch.clientY - window.pageYOffset - bounds.top + parseInt(parentDiv.style.top));
            }else if(touchElement.id.includes("text-image")){
              // タッチしている要素がテキストスタンプの場合
              const imageParentDiv = touchElement.parentElement;
              const cutAreaDiv = imageParentDiv.parentElement;
              offsetXs.push(touch.clientX - window.pageXOffset - bounds.left + parseInt(imageParentDiv.style.left) + parseInt(cutAreaDiv.style.left));
              offsetYs.push(touch.clientY - window.pageYOffset - bounds.top + parseInt(imageParentDiv.style.top) + parseInt(cutAreaDiv.style.left));
            }else{
              // 上記以外 答案用紙divの場合
              const bounds = touchElement.getBoundingClientRect();
              offsetXs.push(touch.clientX - window.pageXOffset - bounds.left) 
              offsetYs.push(touch.clientY - window.pageYOffset - bounds.top)
            }
          }

          // 解答用紙原寸大換算のピンチ中心座標取得
          const offsetX1 = offsetXs[0] > offsetXs[1] ? offsetXs[1] : offsetXs[0];
          const offsetX2 = offsetXs[0] > offsetXs[1] ? offsetXs[0] : offsetXs[1];
          const offsetY1 = offsetYs[0] > offsetYs[1] ? offsetYs[1] : offsetYs[0];
          const offsetY2 = offsetYs[0] > offsetYs[1] ? offsetYs[0] : offsetYs[1];
          const offsetX = offsetX1 + ((offsetX2 - offsetX1) / 2);
          const offsetY = offsetY1 + ((offsetY2 - offsetY1) / 2);
          state.pinchOffsetX = offsetX / scale.value;
          state.pinchOffsetY = offsetY / scale.value;

          const rootDiv = document.getElementById(`answer-page-root-${props.direction}-${props.sheet_type}`);
          state.pinchMarginX = offsetX - rootDiv.scrollLeft;
          state.pinchMarginY = offsetY - rootDiv.scrollTop;
        }
      }
    }

    /************************************************************
     * 画像上をtouchend
     ************************************************************/

    const imageAreaTouchend = (e: TouchEvent) => {
      state.baseDistance = 0;
      state.touchLength = e.touches.length;
    }

    /****************************************
     * 画像エリアpointerdown
     ****************************************/

     const imageAreaPointerDown = (e: PointerEvent) => {
      state.currentDiscription = null;
    }

    /************************************************************
     * リンクアイコンクリック
     ************************************************************/

     const discriptionClick = (discription: any) => {
      state.currentDiscription = discription;
    }

    /******************************
     * 倍率スライダー
     ******************************/

    watch(() => state.inputScale, (newVal, oldVal) => {

      if(state.touchLength == 0){
        const pageRoot = document.getElementById(`answer-page-root-${props.direction}-${props.sheet_type}`);
        const baseOffsetX = (pageRoot.scrollLeft + (pageRoot.offsetWidth / 2)) / (oldVal / 100);
        const baseOffsetY = (pageRoot.scrollTop + (pageRoot.offsetHeight / 2)) / (oldVal / 100);
        const centerX = pageRoot.offsetWidth / 2;
        const centerY = pageRoot.offsetHeight / 2;

        const newOffsetX = baseOffsetX * (Number(newVal) / 100);
        const newOffsetY = baseOffsetY * (Number(newVal) / 100);

        pageRoot.scrollLeft = newOffsetX - centerX;
        pageRoot.scrollTop = newOffsetY - centerY;
      }
    });

    /******************************
     * マウスホイール拡大縮小
     ******************************/

    const imageAreaMousewheel = (e: WheelEvent) => {
      if(props.keyCode == "Control" || e.ctrlKey){
        e.preventDefault();
        const newScale = state.inputScale - (e.deltaY / 30);
        if(newScale >= 10 && newScale <= 200){
          state.inputScale = newScale;
        }
      }
    }

    return {
      ...toRefs(state),
      drawAreaRef,
      selectedPageItem,
      cutAreaKeyPrefix,
      areaHeightStyle,
      imageWrapStyle,
      scale,
      changeSelectedBaseSheetField,
      isKaitouCompleted,
      pageChanged,
      renderCanvas,
      changeSelectedStamp,
      deleteTextStamp,
      deleteImageStamp,
      addTextStamp,
      fieldClicked,
      changeDrawModeFromChild,
      imageAreaTouchstart,
      imageAreaTouchmove,
      imageAreaTouchend,
      imageAreaMousewheel,
      imageAreaPointerDown,
      discriptionClick,
      changeCurrentMode,
      updateCanvas,
      setIsCanvasDrawedFromChild,
      isExistsAnswerTypeImage,
      inputScaleChanged,
    }
  }
});
